export class TelegramSDK {
  private static _initData: string = ''
  private static readonly SPARK_HAPTIC_PATTERNS: ReadonlyArray<ReadonlyArray<'light' | 'medium' | 'heavy'>> = [
    ['light'],
    ['light', 'light'],
    ['medium'],
    ['medium', 'light'],
    ['medium', 'medium'],
    ['heavy'],
    ['heavy', 'light'],
    ['heavy', 'medium'],
    ['heavy', 'heavy'],
    ['heavy', 'heavy', 'medium'],
  ]

  static init(): void {
    const tg = window.Telegram?.WebApp as (
      | {
        ready: () => void
        expand: () => void
        requestFullscreen?: () => void
        disableVerticalSwipes?: () => void
        setupSwipeBehavior?: (options: { allow_vertical_swipe: boolean }) => void
        setHeaderColor: (color: string) => void
        setBackgroundColor: (color: string) => void
        enableClosingConfirmation: () => void
        initData: string
        isFullscreen?: boolean
      }
      | undefined
    )

    if (tg) {
      tg.ready()
      tg.expand()
      // Request fullscreen to remove Telegram header and use full device screen
      if (tg.requestFullscreen && !tg.isFullscreen) {
        try { tg.requestFullscreen() } catch { /* not supported in older clients */ }
      }
      tg.disableVerticalSwipes?.()
      tg.setupSwipeBehavior?.({ allow_vertical_swipe: false })
      tg.setHeaderColor('#00020a')
      tg.setBackgroundColor('#00020a')
      tg.enableClosingConfirmation()
      if (tg.initData) {
        TelegramSDK._initData = tg.initData
      }
    }
  }

  static refreshInitData(): string {
    const liveInitData = window.Telegram?.WebApp?.initData
    if (liveInitData) {
      TelegramSDK._initData = liveInitData
    }
    return TelegramSDK._initData
  }

  static async waitForInitData(timeoutMs: number = 1500, pollMs: number = 50): Promise<string> {
    const deadline = Date.now() + timeoutMs
    let initData = TelegramSDK.refreshInitData()
    while (!initData && Date.now() < deadline) {
      await new Promise((resolve) => setTimeout(resolve, pollMs))
      initData = TelegramSDK.refreshInitData()
    }
    return initData
  }

  static get initData(): string {
    return TelegramSDK.refreshInitData()
  }

  static get isInTelegram(): boolean {
    return !!window.Telegram?.WebApp?.initData
  }

  static get hasWebAppContext(): boolean {
    return !!window.Telegram?.WebApp
  }

  static hapticLight(): void {
    TelegramSDK.impact('light')
  }

  static hapticSparkValue(value: number): void {
    const clamped = Math.max(1, Math.min(TelegramSDK.SPARK_HAPTIC_PATTERNS.length, Math.floor(value)))
    const pattern = TelegramSDK.SPARK_HAPTIC_PATTERNS[clamped - 1]
    for (let i = 0; i < pattern.length; i++) {
      const style = pattern[i]
      if (i === 0) {
        TelegramSDK.impact(style)
        continue
      }
      window.setTimeout(() => TelegramSDK.impact(style), i * 35)
    }
  }

  private static impact(style: 'light' | 'medium' | 'heavy'): void {
    window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(style)
  }
}
